export default "__VITE_ASSET__aiOPPent__"